import React from 'react';
import { NextPage } from 'next';

import { ErrorLayout } from '@components/organisms';

const NotFound: NextPage = () => {
  return (
    <ErrorLayout title="The page you were looking for could not be found." />
  );
};

export default NotFound;
